var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.form, rules: _vm.rules, "label-width": "220px" }
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "商家基本信息", name: "first" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商家id" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.supply_id,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_id", $$v)
                      },
                      expression: "form.supply_id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家名称" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.supply_name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_name", $$v)
                      },
                      expression: "form.supply_name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否可刷单", prop: "is_scal" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_scal,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_scal", $$v)
                        },
                        expression: "form.is_scal"
                      }
                    },
                    _vm._l(_vm.is_scal_options, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家状态", prop: "supply_status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.supply_status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_status", $$v)
                        },
                        expression: "form.supply_status"
                      }
                    },
                    _vm._l(_vm.supply_status, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "交易方式", prop: "settle_type" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "flex-direction": "row" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: { disabled: true },
                              model: {
                                value: _vm.form.settle_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "settle_type", $$v)
                                },
                                expression: "form.settle_type"
                              }
                            },
                            _vm._l(_vm.settle_type, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.settle_type == 2
                        ? _c("SupplySelect", {
                            attrs: {
                              data: {
                                is_signed_contract: _vm.form.is_signed_contract,
                                settle_days: _vm.form.settle_days
                              },
                              disabled: true
                            },
                            on: { "return-data": _vm.returnData }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "城市", prop: "city" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.city,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "city", $$v)
                        },
                        expression: "form.city"
                      }
                    },
                    _vm._l(_vm.citys, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "市场", prop: "father_market" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.father_market,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "father_market", $$v)
                        },
                        expression: "form.father_market"
                      }
                    },
                    _vm._l(_vm.market, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.label, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "子市场", prop: "market_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.market_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "market_id", $$v)
                        },
                        expression: "form.market_id"
                      }
                    },
                    _vm._l(_vm.child_market, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.label, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "楼层", prop: "supply_floor" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.supply_floor,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_floor", $$v)
                        },
                        expression: "form.supply_floor"
                      }
                    },
                    _vm._l(_vm.floor, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "区域/街", prop: "supply_area_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.supply_area_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_area_id", $$v)
                        },
                        expression: "form.supply_area_id"
                      }
                    },
                    _vm._l(_vm.supply_area_list, function(item) {
                      return _c("el-option", {
                        key: item.supply_area_id,
                        attrs: {
                          label: item.supply_area,
                          value: item.supply_area_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "档口号", prop: "supplier_num" } },
                [
                  _c("el-autocomplete", {
                    staticClass: "inline-input",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.supplier_num,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supplier_num", $$v)
                      },
                      expression: "form.supplier_num"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家地址" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.supply_address,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_address", $$v)
                      },
                      expression: "form.supply_address"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "一手商城档口名" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.supply_nickname,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_nickname", $$v)
                      },
                      expression: "form.supply_nickname"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌", prop: "brand" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%", float: "left" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.brand,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "brand", $$v)
                      },
                      expression: "form.brand"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "代采组", prop: "pgid" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.pgid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pgid", $$v)
                        },
                        expression: "form.pgid"
                      }
                    },
                    _vm._l(_vm.pg_list, function(item) {
                      return _c("el-option", {
                        key: item.pgid,
                        attrs: { label: item.pgname, value: item.pgid }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "代采员", prop: "pg_member_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.pg_member_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pg_member_id", $$v)
                        },
                        expression: "form.pg_member_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "全部" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.memberOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "次品组", prop: "dgid" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.dgid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "dgid", $$v)
                        },
                        expression: "form.dgid"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "请选择" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.defectiveGroupOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "次品员", prop: "dg_member_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.dg_member_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "dg_member_id", $$v)
                        },
                        expression: "form.dg_member_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "请选择" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.defectiveGroupMemberOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "买手组", prop: "pg_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.pg_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pg_id", $$v)
                        },
                        expression: "form.pg_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "无" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.pickers, function(item) {
                        return _c("el-option", {
                          key: item.pg_id,
                          attrs: { label: item.pg_name, value: item.pg_id }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "买手",
                    prop: "supply_picker_group_member_id"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.supply_picker_group_member_id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "supply_picker_group_member_id",
                            $$v
                          )
                        },
                        expression: "form.supply_picker_group_member_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "无" }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.PickerGroupMemberOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家运营跟进人", prop: "follower" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.follower_admin_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "follower_admin_id", $$v)
                        },
                        expression: "form.follower_admin_id"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "0",
                        attrs: { value: "0", label: "请选择" }
                      }),
                      _vm._v(" "),
                      _vm._l((_vm.resData || {}).follower, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: {
                            disabled: item.admin_status == 0,
                            label: item.label,
                            value: item.value
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家开发人", prop: "supply_developer" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: true },
                      model: {
                        value: _vm.form.supply_developer_admin,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_developer_admin", $$v)
                        },
                        expression: "form.supply_developer_admin"
                      }
                    },
                    _vm._l(_vm.supply_developer, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "联系方式" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.supply_mobile_phone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_mobile_phone", $$v)
                      },
                      expression: "form.supply_mobile_phone"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.supply_wechat,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_wechat", $$v)
                      },
                      expression: "form.supply_wechat"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品默认活跃值",
                    prop: "supply_action_value"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "45%" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.supply_action_value,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "supply_action_value", $$v)
                      },
                      expression: "form.supply_action_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排单锁定天数", prop: "limit_day" } },
                [
                  _c("el-input", {
                    attrs: { type: "number", disabled: true },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function() {
                          return [_vm._v("天")]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.form.limit_day,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "limit_day", $$v)
                      },
                      expression: "form.limit_day"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.form.payees, function(payee, index) {
                return _c(
                  "el-form-item",
                  {
                    key: payee.key,
                    attrs: {
                      label: "收款人信息" + (index + 1),
                      prop: "payee." + index + ".value",
                      prop: ""
                    }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: {
                        disabled: "",
                        value:
                          payee.payee_name +
                          "-" +
                          payee.payee_bank +
                          "-" +
                          payee.cnap_name +
                          "-" +
                          payee.payee_bank_account,
                        disabled: true
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: index, disabled: true },
                        model: {
                          value: _vm.form.is_default,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "is_default", $$v)
                          },
                          expression: "form.is_default"
                        }
                      },
                      [_vm._v("默认收款账号\n        ")]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", disabled: true },
                    model: {
                      value: _vm.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark"
                    }
                  })
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "商家权限", name: "second" } },
            [
              _vm._v("商家权限\n      "),
              _c(
                "el-form-item",
                { attrs: { label: "是否KA", prop: "is_ka" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_ka,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_ka", $$v)
                        },
                        expression: "form.is_ka"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否实力档口", prop: "is_strength" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_strength,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_strength", $$v)
                        },
                        expression: "form.is_strength"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "售后提前代采计划", prop: "as_plan" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.as_plan,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "as_plan", $$v)
                        },
                        expression: "form.as_plan"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "重新代采计划全量生成",
                    prop: "all_rebuild_plan"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.all_rebuild_plan,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "all_rebuild_plan", $$v)
                        },
                        expression: "form.all_rebuild_plan"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "退换货是否需接收", prop: "reject_accept" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.reject_accept,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "reject_accept", $$v)
                        },
                        expression: "form.reject_accept"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否全款全上", prop: "is_strength" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_full,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_full", $$v)
                        },
                        expression: "form.is_full"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否自主上款", prop: "is_self" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_self,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_self", $$v)
                        },
                        expression: "form.is_self"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "支付方式", prop: "is_self" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.pay_method,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pay_method", $$v)
                        },
                        expression: "form.pay_method"
                      }
                    },
                    _vm._l(_vm.options.pay_methods, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.effective_time
                    ? _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("生效时间 " + _vm._s(_vm.form.effective_time))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否轻入驻", prop: "is_lower_enter" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_lower_enter,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_lower_enter", $$v)
                        },
                        expression: "form.is_lower_enter"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.is_lower_enter == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "月目标", prop: "m_goal" } },
                    [
                      _c("el-input", {
                        attrs: { type: "number", disabled: true },
                        model: {
                          value: _vm.form.m_goal,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "m_goal", $$v)
                          },
                          expression: "form.m_goal"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否开启直播", prop: "is_live" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_live,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_live", $$v)
                        },
                        expression: "form.is_live"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "是否开启截图上款",
                    prop: "is_screenshot_for_add_goods"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_screenshot_for_add_goods,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_screenshot_for_add_goods", $$v)
                        },
                        expression: "form.is_screenshot_for_add_goods"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.is_live == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "直播频率", prop: "live_type" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "1", disabled: true },
                          model: {
                            value: _vm.form.live_type,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "live_type", $$v)
                            },
                            expression: "form.live_type"
                          }
                        },
                        [_vm._v("按次申请")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "2", disabled: true },
                          model: {
                            value: _vm.form.live_type,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "live_type", $$v)
                            },
                            expression: "form.live_type"
                          }
                        },
                        [_vm._v("不限直播次数")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "3", disabled: true },
                          model: {
                            value: _vm.form.live_type,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "live_type", $$v)
                            },
                            expression: "form.live_type"
                          }
                        },
                        [
                          _vm._v("每周可自主直播\n          "),
                          _vm.form.live_type == 3
                            ? _c("el-input", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  type: "text",
                                  value: _vm.form.live_num,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.form.live_num,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "live_num", $$v)
                                  },
                                  expression: "form.live_num"
                                }
                              })
                            : _vm._e(),
                          _vm._v("\n          次\n        ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "4", disabled: true },
                          model: {
                            value: _vm.form.live_type,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "live_type", $$v)
                            },
                            expression: "form.live_type"
                          }
                        },
                        [
                          _vm._v("每月可自主直播\n          "),
                          _vm.form.live_type == 4
                            ? _c("el-input", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  type: "text",
                                  value: _vm.form.live_num,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.form.live_num,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "live_num", $$v)
                                  },
                                  expression: "form.live_num"
                                }
                              })
                            : _vm._e(),
                          _vm._v("\n          次\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "履约率标杆商家", prop: "is_benchmarking" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_benchmarking,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_benchmarking", $$v)
                        },
                        expression: "form.is_benchmarking"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "自主上款是否需要审核",
                    prop: "is_self_need_audit"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_self_need_audit,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_self_need_audit", $$v)
                        },
                        expression: "form.is_self_need_audit"
                      }
                    },
                    _vm._l(_vm.is_self_need_audit, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "是否邀请商家自主申请入驻",
                    prop: "open_deposit"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.open_deposit,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "open_deposit", $$v)
                        },
                        expression: "form.open_deposit"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "商家标签", name: "third" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "擅长季节", prop: "season" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { lable: "擅长季节", disabled: true },
                      model: {
                        value: _vm.form.season,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "season", $$v)
                        },
                        expression: "form.season"
                      }
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "春季" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "夏季" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "秋季" } }),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "冬季" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "适合年龄阶段", prop: "season" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.age_group,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "age_group", $$v)
                        },
                        expression: "form.age_group"
                      }
                    },
                    _vm._l(_vm.age_group_list, function(age) {
                      return _c(
                        "el-checkbox",
                        {
                          key: age.key,
                          attrs: { label: age.key, disabled: true }
                        },
                        [_vm._v(_vm._s(age.label) + "\n          ")]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "档次", prop: "supply_grade" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { lable: "档次" },
                      model: {
                        value: _vm.form.supply_grade,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "supply_grade", $$v)
                        },
                        expression: "form.supply_grade"
                      }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { label: "低端", disabled: true }
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: { label: "中低", disabled: true }
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: { label: "中端", disabled: true }
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: { label: "中高", disabled: true }
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: { label: "高端", disabled: true }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "擅长品类" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.category,
                      props: { multiple: true },
                      filterable: "",
                      disabled: true
                    },
                    model: {
                      value: _vm.form.cat_ids,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cat_ids", $$v)
                      },
                      expression: "form.cat_ids"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "主要风格" } },
                [
                  _c("el-transfer", {
                    attrs: {
                      filterable: "",
                      titles: ["选项", "选中"],
                      data: _vm.styles_data,
                      disabled: true
                    },
                    model: {
                      value: _vm.form.styles,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "styles", $$v)
                      },
                      expression: "form.styles"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "副风格" } },
                [
                  _c("el-transfer", {
                    attrs: {
                      filterable: "",
                      titles: ["选项", "选中"],
                      data: _vm.second_styles_data,
                      disabled: true
                    },
                    on: { change: _vm.build_styles },
                    model: {
                      value: _vm.form.second_styles,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "second_styles", $$v)
                      },
                      expression: "form.second_styles"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "一手店铺底图" } },
                [
                  _c(
                    "el-col",
                    { style: "width:100%;", attrs: { span: 24 } },
                    [
                      _vm._l(_vm.images1, function(item, index) {
                        return _vm.images1
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticStyle: {
                                  float: "left",
                                  width: "50px",
                                  height: "50px",
                                  margin: "0 10px",
                                  border: "1px solid #ddd"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { position: "relative" } },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "50px",
                                        height: "50px"
                                      },
                                      attrs: { src: item },
                                      on: {
                                        click: function($event) {
                                          return _vm.previewImage(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "档口实拍图" } },
                [
                  _c(
                    "el-col",
                    { staticStyle: { width: "100%" }, attrs: { span: 24 } },
                    [
                      _vm._l(_vm.images4, function(item, index) {
                        return _vm.images4
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticStyle: {
                                  float: "left",
                                  width: "50px",
                                  height: "50px",
                                  margin: "0 10px",
                                  border: "1px solid #ddd"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { position: "relative" } },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "50px",
                                        height: "50px"
                                      },
                                      attrs: { src: item },
                                      on: {
                                        click: function($event) {
                                          return _vm.previewImage(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌logo" } },
                [
                  _c(
                    "el-col",
                    { style: "width:100%;", attrs: { span: 24 } },
                    [
                      _vm._l(_vm.images3, function(item, index) {
                        return _vm.images3
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticStyle: {
                                  float: "left",
                                  width: "50px",
                                  height: "50px",
                                  margin: "0 10px",
                                  border: "1px solid #ddd"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { position: "relative" } },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "50px",
                                        height: "50px"
                                      },
                                      attrs: { src: item },
                                      on: {
                                        click: function($event) {
                                          return _vm.previewImage(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "营业执照" } },
                [
                  _c(
                    "el-col",
                    { style: "width:100%;", attrs: { span: 24 } },
                    [
                      _vm._l(_vm.images2, function(item, index) {
                        return _vm.images2
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticStyle: {
                                  float: "left",
                                  width: "50px",
                                  height: "50px",
                                  margin: "0 10px",
                                  border: "1px solid #ddd"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { position: "relative" } },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "50px",
                                        height: "50px"
                                      },
                                      attrs: { src: item },
                                      on: {
                                        click: function($event) {
                                          return _vm.previewImage(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "视频" } }, [
                _vm.form.supply_video
                  ? _c("video", {
                      staticStyle: {
                        "max-width": "80px",
                        "max-height": "80px"
                      },
                      attrs: {
                        src: _vm.form.supply_video,
                        preload: "metadata"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleViewVideo(_vm.form.supply_video)
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "推荐描述" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "40%", float: "left" },
                    attrs: { maxlength: "100", disabled: true },
                    model: {
                      value: _vm.form.recommend_desc,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "recommend_desc", $$v)
                      },
                      expression: "form.recommend_desc"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      "一手APP上的商家推荐描述（建议30字以内，否则在手机上超出的部分可能会变为省略号）"
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌介绍" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.pg_say,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "pg_say", $$v)
                      },
                      expression: "form.pg_say"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "爆版权限", name: "fourth" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "爆版手机账号" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.baobmobile,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "baobmobile", $$v)
                      },
                      expression: "form.baobmobile"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("（数据同步时间：" + _vm._s(_vm.data_date) + "）")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "爆版店铺", prop: "shopId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.shopId,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shopId", $$v)
                        },
                        expression: "form.shopId"
                      }
                    },
                    _vm._l(_vm.shop_list, function(item) {
                      return _c("el-option", {
                        key: item.shopId,
                        attrs: { label: item.shopName, value: item.shopId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否自主上款", prop: "is_self" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_self,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_self", $$v)
                        },
                        expression: "form.is_self"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "自主设置一手独家款", prop: "self_set_sole" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.self_set_sole,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "self_set_sole", $$v)
                        },
                        expression: "form.self_set_sole"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "自主上款全类目", prop: "is_all_style" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_all_style,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_all_style", $$v)
                        },
                        expression: "form.is_all_style"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "开通爆版开单", prop: "is_order_ability" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.is_order_ability,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_order_ability", $$v)
                        },
                        expression: "form.is_order_ability"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "开通库存共享", prop: "baob_stock_sharing" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.baob_stock_sharing,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "baob_stock_sharing", $$v)
                        },
                        expression: "form.baob_stock_sharing"
                      }
                    },
                    _vm._l(_vm.public_option, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ad9cbb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad9cbb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/ShowSupply.vue
// module id = null
// module chunks = 